import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    itensporpagina: 10,
    drawerExpanded: true,
    drawerShow: true,
    dateMask: "##/##/##",
    procPjeMask: "#######-##.####.#.##.####",
    _temaRouteLabel: "",
    headers: [],
    fileload: false,
  }),
  getters: {
    
  },
  actions: {
    
  },
})
